<template>
<div class="ls-body">
    <div class="ft-bar" ref="filter_bar" :style="{'height': barHeight ? (barHeight + 'px') : 'auto'}">
      <div :class="filterFixed ? 'filter ft-fixed': 'filter'" v-if="!hiddenFilter">
          <div class="ft-row">
            <div :class="openSort ? 'ft open-ft': 'ft close-ft'">
              <span class="ft-name" @click="openSortSelector">{{sortTitle || '智能排序'}}</span><i class="iconfont uc-sanjiaoxing"></i>
            </div>
            <div class="ft">
              <span class="ft-brand" @click="openBrandSelector">品牌</span><i class="iconfont uc-sanjiaoxing"></i>
            </div>
            <div :class="openPriceFilter ? 'ft open-ft': 'ft close-ft'">
              <span class="ft-price" @click="openPriceSelector">价格</span><i class="iconfont uc-sanjiaoxing"></i>
            </div>
          </div>
          <div class="ft-selected" v-if="queryParams.qc_manufactor.length > 0 || (pickPriceRange.length > 0 && pickPriceRange !== '不限价格')">
            <div class="selected setBorder s" v-if="queryParams.qc_manufactor.length > 0"><span class="txt">{{queryParams.qc_manufactor}}</span><b class="iconfont uc-guanbi" @click="onClearBrandFilter"></b></div>
            <div class="selected setBorder d" v-if="pickPriceRange.length > 0 && pickPriceRange !== '不限价格'"><span class="txt">{{pickPriceRange}}</span><b class="iconfont uc-guanbi" @click="onClearPriceFilter"></b></div>
          </div>
      </div>
    </div>
    <base-car-list :sourceList="recommandList" v-if="recommandList.length > 0"/>
    <div class="no-data"  v-else-if="dataLoaded && recommandList.length === 0">
      <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/empty-content.png" class="emp-img"/>
      <span class="emp-txt">没找到车辆信息</span>
    </div>
    <div class="load-more-list" v-if="listLoading">
      <div class="loading"><mt-spinner type="triple-bounce" color="rgb(38, 162, 255)"></mt-spinner><div class="txt">努力加载中...</div></div>
    </div>
    <div class="data-load-over" v-if="dataLoadOver && recommandList.length > 0">
      <div class="loaded">加载完了，再没有啦～</div>
    </div>
    <mt-popup
      v-model="openPriceFilter"
      @touchmove.native.stop.prevent
      class="mt-popup"
      position="bottom"
    >
      <div class="popup-container" @touchmove.prevent>
        <div class="title">
          <h3>请选择价格区间</h3>
        </div>
        <div class="content">
          <mt-picker @touchmove.native.stop.prevent :slots="slots" @change="onPriceValuesChange"></mt-picker>
        </div>
        <div class="btn-row">
          <button class="btm-popup-ok" @click="onConfirmPriceRange">确定</button>
        </div>
      </div>
    </mt-popup>
    <mt-popup
      v-model="openSort"
      @touchmove.native.stop.prevent
      class="mt-popup"
      position="bottom"
    >
      <div class="popup-container" @touchmove.prevent>
        <div class="title">
          <h3>请列表排序</h3>
        </div>
        <div class="content">
          <mt-picker @touchmove.native.stop.prevent :slots="slotsSort" @change="onSortValuesChange"></mt-picker>
        </div>
        <div class="btn-row">
          <button class="btm-popup-ok" @click="onConfirmSortType">确定</button>
        </div>
      </div>
    </mt-popup>
    <brands-select :openBrandBox="openBrand" v-on:onClosed="openBrand = false" v-on:onSelected="onConfirmBrand"/>
</div>
</template>

<script>
import { deepClone } from '../../utils'
import BaseCarList from './baseCarList'
import { getUsedCarList } from '../../api'
import brandsSelect from '../widget/brandsSelect'
import { Picker, Popup, Spinner } from 'mint-ui'
const pickList = ['不限价格', '5万元以内', '5万至10万之间', '10万至20万之间', '20万以上']
const pickValue = [
    {"qc_priceGte": "", "qc_priceLte": ""},
    {"qc_priceGte": 0, "qc_priceLte": 5000000},
    {"qc_priceGte": 5000000, "qc_priceLte": 10000000},
    {"qc_priceGte": 10000000, "qc_priceLte": 20000000},
    {"qc_priceGte": 20000000, "qc_priceLte": 100000000}
  ]
const sortList = ['默认排序', '价格最高', '价格最低', '里程最长', '里程最短']
const sortValue = [
  {},
  {"qc_sortField": "price", "qc_sortRule": "DESC"},
  {"qc_sortField": "price", "qc_sortRule": "ASC"},
  {"qc_sortField": "trip", "qc_sortRule": "DESC"},
  {"qc_sortField": "trip", "qc_sortRule": "ASC"}
]
export default {
  components: {
      [Picker.name]: Picker,
      [Popup.name]: Popup,
      [Spinner.name]: Spinner,
      BaseCarList,
      brandsSelect
  },
  props: {
    hiddenFilter: {//是否显示筛选栏
      type: Boolean,
      default: false
    },
    enableAutoLoaded: {//开启自动加载下一步
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listLoading: false,//正加载中
      dataLoadOver: false,
      barHeight: 0,
      sortTitle: "",
      filterFixed: false,
      openSort: false,
      openBrand: false,
      openPriceFilter: false,
      dataLoaded: false,
      slots: [
        {
          flex: 1,
          values: pickList,
          className: 'slot1',
          defaultIndex: 0,
          textAlign: 'center'
        }
      ],
      slotsSort: [
        {
          flex: 1,
          values: sortList,
          className: 'slot1',
          defaultIndex: 0,
          textAlign: 'center'
        }
      ],
      pickCache: [],
      pickPriceRange: "",
      brandName: "",
      recommandList: [],
      queryParams: {
        qc_manufactor: "",//品牌
        qc_priceGte: "",//价格小于
        qc_priceLte: "",//价格大于
        qc_tripGte: "",//公里数大于等于
        qc_tripLte: "",//公里数小于等于
        page: 1,
        qc_status: 1,
        rows: 8
      }
    };
  },
  watch: {
    openSort(newval){
      this.resetBarHeight()
    },
    openPriceFilter(newval){
      this.resetBarHeight()
    }
  },
  computed: {
  },
  methods: {
    //打开排序弹框
    openSortSelector(){
      this.openSort = true
      this.toTop()
      this.barHeight = 0
    },
    //打开价格弹框
    openPriceSelector(){
      this.openPriceFilter = true;
      this.toTop()
      this.barHeight = 0
    },
    //打开品牌选择器
    openBrandSelector(){
      this.openBrand = true
      this.toTop()
      this.barHeight = 0
    },
    resetBarHeight(){//重置筛选栏高度
      if(this.$refs.filter_bar){
        this.barHeight = this.$refs.filter_bar.offsetHeight
      }
    },
    //删除价格品牌筛选条件
    async onClearBrandFilter(){
      this.queryParams.qc_manufactor=''
      this.dataLoadOver = false
      await this.loadRecommandCars(true)  
      this.barHeight = 0
      this.$nextTick(()=>{
        this.resetBarHeight()
      })
    },
    //删除价格筛选条件
    async onClearPriceFilter(){
      this.pickCache = [];
      this.pickPriceRange = ''
      this.queryParams.qc_priceGte = ''
      this.queryParams.qc_priceLte = ''
      this.slots[0].defaultIndex = 0
      this.dataLoadOver = false
      await this.loadRecommandCars(true)  
      this.barHeight = 0  
      this.$nextTick(()=>{
        this.resetBarHeight()
      })
    },
    //价格滑动，值变动
    onPriceValuesChange(picker){
      this.pickCache = picker.getValues()
    },
    //排序滑动时，值变动
    onSortValuesChange(picker){
      this.pickSortCache = picker.getValues()
    },
    //选择排序确认回调
    async onConfirmSortType(){
      const sortName = this.pickSortCache[0]
      this.sortTitle = sortName === '默认排序' ? null : sortName
      const _index = sortList.indexOf(sortName)
      const sorted = sortValue[_index]
      this.slotsSort[0].defaultIndex = _index
      this.queryParams = {...this.queryParams, ...sorted, page: 1}
      this.dataLoadOver = false
      await this.loadRecommandCars(true)
      this.openSort = false
      this.resetBarHeight()
    },
    //选择价格确认回调
    async onConfirmPriceRange(){
      this.pickPriceRange = this.pickCache[0]
      const _index = pickList.indexOf(this.pickCache[0])
      const range = pickValue[_index]
      this.slots[0].defaultIndex = _index
      this.queryParams = {...this.queryParams, ...range, page: 1}
      this.dataLoadOver = false
      await this.loadRecommandCars(true)
      this.openPriceFilter = false
      this.resetBarHeight()
    },
    //选择品牌确认回调
    async onConfirmBrand(item){
      this.queryParams.qc_manufactor = item.name
      this.queryParams.page = 1
      this.openBrand = false
      this.dataLoadOver = false
      await this.loadRecommandCars(true)
      this.resetBarHeight()
    },
    //加载列表数据
    async loadRecommandCars(overWrite){
        let query = deepClone(this.queryParams)
        const ret = await getUsedCarList(query)
        if(ret.code === 0){
          this.dataLoaded = true
          const { total, pages, size, current } = ret.data
          if(ret.data.records.length > 0){
            this.recommandList = overWrite ? ret.data.records : this.recommandList.concat(ret.data.records)
            this.listLoading = false
            this.dataLoadOver = current >= pages
          }else if(current === 1){
            this.recommandList = []
            this.listLoading = false
            this.dataLoadOver = true
          }
        }
    },
    showFilterBar(){
      if(this.$refs.filter_bar){
        const toTop = this.$refs.filter_bar.getBoundingClientRect().top
        if(toTop <= 0){
          this.filterFixed = true
        }else{
          this.filterFixed = false
        }
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop //距离顶部的距离
        const windowHeight = document.documentElement.clientHeight || document.body.clientHeight //可视区的高度
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight //滚动条的总高度
        if(Math.abs(scrollTop + windowHeight - scrollHeight) < 2 && !this.listLoading && this.enableAutoLoaded && !this.dataLoadOver){
          this.queryParams.page ++
          this.listLoading = true
          this.loadRecommandCars().then(resp => {
            console.log('resp:', resp)
          })
        }
      }
    },
    //滚动到顶部
    toTop() {
      if(this.$refs.filter_bar){
        const extraTop = this.$refs.filter_bar.getBoundingClientRect().top
        const existTop = document.body.scrollTop || document.documentElement.scrollTop
        document.body.scrollTop = document.documentElement.scrollTop = extraTop + existTop
      }
    }
  },
  beforeCreate() {},
  created() {},
  async mounted() {
      await this.loadRecommandCars()
      window.addEventListener("scroll", this.showFilterBar, true)
      this.resetBarHeight()
  },
  destroyed(){
    window.removeEventListener("scroll", this.showFilterBar)
  }
};
</script>
<style lang="scss" scoped>
.ls-body{
    padding: 0rem .2rem;
    .ft-bar{
      //height: .8rem;
      .ft-fixed{
          position: fixed;
          top: 0rem;
          left: .5rem;
          right: .5rem;
          z-index: 2;
        }
        .filter{
            background: #fff;
            display: flex;
            flex-direction: column;
            //padding-left: .05rem;
            .ft-row{
              display: flex;
              font-size: .26rem;
              color:#6a6a6a;
              height: .8rem;
              .ft{
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-right: .5rem;
              }
              .open-ft{
                i{
                  transform:rotate(180deg);
                  transition:transform .13s linear;
                }
              }
              .close-ft{
                i{
                  transform:rotate(0deg);
                  transition:transform .13s linear;
                }
              }
              i{
                margin-left: .08rem;
                color:#6a6a6a;
                font-size: .16rem;
              }
              .ft-name,.ft-brand.ft-price{
                  display: inline-block;
              }
            }
            .ft-selected{
              display: flex;
              height:.6rem;
              background: #fff;
              .selected{
                padding:.05rem .1rem .02rem .1rem;
                border-radius: 50%;
                height: .3rem;
                //line-height: .3rem;
                font-size: .21rem;
                color:#EC8239;
                margin-right: .2rem;
                .txt{
                  display: inline-block;
                }
                b{
                  display: inline-block;
                  padding-left: .05rem;
                  font-size: .23rem;
                  color:#EC8239;
                  position: relative;
                  z-index: 2;
                }
              }
            }
        }
    }
    .setBorder{
     position: relative;
       &:after{
           content:" ";
           position:absolute;
           top: 0;
           left: 0;
           width: 200%;
           height: 200%;
           transform: scale(0.5);
           transform-origin: left top;
           box-sizing: border-box;
           border: 1px solid #EC8239;
           border-radius: .4rem;
      }
  }
}
.mt-popup {
    width: 100%;
    min-height: 2rem;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow: hidden;
    .popup-container {
        width: 100%;
        height: 100%;
        background-color: white;
        .title {
            display: flex;
            color: #333;
            padding: .2rem;
            .h3 {
              font-size: .263rem;
            }
        }
        .content{
            color:#333;
            padding: .13rem .2rem;
            line-height: .23rem;
        }
        .btn-row{
            padding:.3rem;
            text-align: center;
        }
    }
    .btm-popup-ok{
        border: none;
        outline: none;
        padding: .2rem 1.3rem;
        font-size: .23rem;
        border-radius: 3rem;
        color:#fff;
        background: linear-gradient(135deg, #18B8F9, #0C86FF);
        box-shadow: 1px 14px 25px 0px rgba(24, 184, 249, 0.2);
      }
}
.no-data{
  display:flex;
  flex-direction:column;
  align-items: center;
  padding-top: 1rem;
  .emp-img{
    max-width: 5rem;
  }
  .emp-txt{
    padding: .2rem;
    font-size: .23rem;
    color:#999;
  }
}
.load-more-list{
  display: flex;
  justify-content: center;
  padding: .2rem 0rem;
  .loading{
    display: flex;
    font-size: .2rem;
    color:#888;
    .txt{
      padding-left: .18rem;
    }
  }
}
.data-load-over{
  display: flex;
  justify-content: center;
  .loaded{
    padding: .2rem 0rem;
    font-size: .2rem;
    color:#888;
  }
}
</style>